import React from 'react';
import { Link } from 'react-router-dom';
import "../../styles/Css/Careers.css"

const Careers = () => {
    const benefits = [
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                    <polyline points="9 22 9 12 15 12 15 22" />
                </svg>
            ),
            title: 'Remote First',
            description: 'Work from anywhere in the world'
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
                    <line x1="1" y1="10" x2="23" y2="10" />
                </svg>
            ),
            title: 'Competitive Salary',
            description: 'Top-of-market compensation'
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
            ),
            title: 'Health Benefits',
            description: 'Full medical, dental & vision'
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                </svg>
            ),
            title: 'Flexible Hours',
            description: 'Work when you\'re most productive'
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                </svg>
            ),
            title: 'Learning Budget',
            description: '$2,000/year for growth'
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
            ),
            title: 'Team Retreats',
            description: 'Annual in-person gatherings'
        }
    ];

    const openings = [
        {
            title: 'Senior Full Stack Engineer',
            department: 'Engineering',
            location: 'Remote (US)',
            type: 'Full-time'
        },
        {
            title: 'Product Designer',
            department: 'Design',
            location: 'Remote (US)',
            type: 'Full-time'
        },
        {
            title: 'Machine Learning Engineer',
            department: 'AI/ML',
            location: 'Remote (US)',
            type: 'Full-time'
        },
        {
            title: 'Customer Success Manager',
            department: 'Customer Success',
            location: 'Remote (US)',
            type: 'Full-time'
        },
        {
            title: 'Content Marketing Manager',
            department: 'Marketing',
            location: 'Remote (US)',
            type: 'Full-time'
        }
    ];

    return (
        <div className="careers-page">
            {/* Hero */}
            <section className="careers-hero">
                <div className="container">
                    <span className="badge">Careers</span>
                    <h1 className="careers-hero__title">
                        Join Us in Transforming<br />
                        <span className="gradient-text">Real Estate</span>
                    </h1>
                    <p className="careers-hero__subtitle">
                        We're building the future of real estate transaction management.
                        Join our team of passionate innovators.
                    </p>
                    <a href="#openings" className="btn btn-primary btn-lg">
                        View Open Positions
                    </a>
                </div>
            </section>

            {/* Why Join */}
            <section className="careers-why section">
                <div className="container">
                    <h2 className="section-title">Why Join Deal to Close AI?</h2>
                    <p className="section-subtitle">
                        We offer more than just a job — we offer a chance to make a real impact.
                    </p>
                    <div className="benefits__grid">
                        {benefits.map((benefit, index) => (
                            <div key={index} className="benefit-card">
                                <div className="benefit-card__icon">
                                    {benefit.icon}
                                </div>
                                <h3 className="benefit-card__title">{benefit.title}</h3>
                                <p className="benefit-card__description">{benefit.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Culture */}
            <section className="careers-culture section">
                <div className="container">
                    <div className="culture-content">
                        <div className="culture-text">
                            <h2 className="culture-text__title">Our Culture</h2>
                            <p>
                                At Deal to Close AI, we believe in building a company where people
                                can do the best work of their careers. We value transparency,
                                collaboration, and continuous learning.
                            </p>
                            <p>
                                We're a diverse team of engineers, designers, real estate professionals,
                                and business experts united by a common mission: to make real estate
                                transactions seamless for everyone.
                            </p>
                            <ul className="culture-values">
                                <li>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                    Move fast and ship often
                                </li>
                                <li>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                    Customer obsession
                                </li>
                                <li>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                    Radical transparency
                                </li>
                                <li>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                    Own your impact
                                </li>
                            </ul>
                        </div>
                        <div className="culture-image">
                            <div className="culture-image__placeholder">
                                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.3">
                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                    <circle cx="9" cy="7" r="4" />
                                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Open Positions */}
            <section className="careers-openings section" id="openings">
                <div className="container">
                    <h2 className="section-title">Open Positions</h2>
                    <p className="section-subtitle">
                        Find your next opportunity with us.
                    </p>
                    <div className="openings__list">
                        {openings.map((job, index) => (
                            <div key={index} className="job-card">
                                <div className="job-card__info">
                                    <h3 className="job-card__title">{job.title}</h3>
                                    <div className="job-card__meta">
                                        <span className="job-card__department">{job.department}</span>
                                        <span className="job-card__divider">•</span>
                                        <span className="job-card__location">{job.location}</span>
                                        <span className="job-card__divider">•</span>
                                        <span className="job-card__type">{job.type}</span>
                                    </div>
                                </div>
                                <a href="#" className="btn btn-outline job-card__apply">
                                    Apply Now
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="careers-cta">
                <div className="container">
                    <h2 className="careers-cta__title">Don't See Your Role?</h2>
                    <p className="careers-cta__subtitle">
                        We're always looking for talented people. Send us your resume
                        and we'll keep you in mind for future opportunities.
                    </p>
                    <Link to="/contact" className="btn btn-primary btn-lg">
                        Get in Touch
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Careers;
